// @flow

import React, { useState, useEffect } from "react";
import type { SearchCoursesViewContainerState } from "../../utils/_types.js";
import apiFetch from "../../utils/_apiFetch.js";
import { getTranslationCatalog } from "../../utils/_i18n.js";
import Vocabulary from "../../utils/_vocabulary.js";
import SearchCoursesForm from "../SearchCoursesForm";
import SearchCoursesResults from "../SearchCoursesResults";

const SearchCoursesViewContainer = (): React$Node => {
  const [results, setResults] = useState([]);
  const [translations, setTranslations] = useState({});
  const [formParameters, setFormParameters] = useState({
    courses: [],
    course_type: "",
    SearchableText: "",
  });
  const [vocabulary, setVocabulary] = useState({});

  useEffect(() => {
    const query = new URL(document.location).searchParams;
    let searchParams = {
      portal_type: "Course",
      fullobjects: 1,
      b_size: 100,
    };
    const SearchableText = query.get("SearchableText") || "";
    const course_type = query.get("course_type") || "";
    if (SearchableText.length) {
      searchParams.SearchableText = SearchableText + "*";
    }
    if (course_type.length) {
      searchParams.course_type = course_type;
    }

    const formFieldsParams = {
      portal_type: "Course",
      b_size: 200,
      metadata_fields: [
        "course_type",
        "Description",
        "class_code",
        "UID",
        "external_website",
      ],
    };

    const fetches = [
      apiFetch({
        url: "@search",
        params: searchParams,
        method: "GET",
        restApi: true,
      }),
      apiFetch({
        url: "@search",
        params: formFieldsParams,
        method: "GET",
        restApi: true,
      }),
      getTranslationCatalog(),
      Vocabulary.getVocabularies("unife.vocabularies", [
        "Departments",
        "Venue",
        "AccessType",
        "CourseLanguage",
        "CourseClass",
        "DoubleTitle",
        "CourseTypes",
      ]),
    ];

    Promise.all(fetches).then(
      ([searchResults, formParametersData, translationsData, vocabularies]) => {
        setResults(searchResults.items);
        setFormParameters({
          courses: formParametersData.items,
          course_type,
          SearchableText,
        });
        setTranslations(translationsData);
        setVocabulary(vocabularies);
      }
    );
  }, []);

  const updateSearchResults = (e: any): void => {
    e.preventDefault();
    const { SearchableText, course_type } = formParameters;
    let params = {
      portal_type: "Course",
      fullobjects: 1,
      b_size: 200,
    };
    if (SearchableText.length) {
      params.SearchableText = SearchableText + "*";
    }
    if (course_type.length) {
      params.course_type = course_type;
    }
    apiFetch({
      url: "@search",
      params,
      method: "GET",
      restApi: true,
    }).then(({ data }) => {
      setResults(data.items);
    });
  };

  const updateFormValue = (newValue: any): void => {
    setFormParameters((prev) => ({ ...prev, ...newValue }));
  };

  return (
    <div className="courses-search-results">
      <SearchCoursesForm
        {...formParameters}
        translations={translations}
        onSubmitHandle={updateSearchResults}
        onUpdateFormValue={updateFormValue}
        vocabulary={vocabulary}
      />
      <SearchCoursesResults
        translations={translations}
        results={results}
        vocabulary={vocabulary}
      />
    </div>
  );
};

export default SearchCoursesViewContainer;
